import '../App.css';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '../components/Header';
import PricingSection from '../components/PricingSection';

function PricingPage() {
  const [backendAuth, setBackendAuth] = useState({ isAuthenticated: false, user: null, loading: true });

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch('/auth/status', {
          credentials: 'include',
        });
        if (response.ok) {
          const authData = await response.json();
          setBackendAuth({
            isAuthenticated: authData.isAuthenticated,
            user: authData.user,
            loading: false,
          });
        } else {
          setBackendAuth({ isAuthenticated: false, user: null, loading: false });
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
        setBackendAuth({ isAuthenticated: false, user: null, loading: false });
      }
    };

    checkAuthStatus();
  }, []);

  const isAuthenticated = backendAuth.isAuthenticated;
  const isLoading = backendAuth.loading;
  const currentUser = backendAuth.user;

  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleLogout = () => {
    window.location.href = '/logout';
  };

  const navigate = useNavigate();

  const handleViewChange = view => {
    if (view === 'pricing') {
      navigate('/pricing');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="App">
      <Header
        isLoading={isLoading}
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLogin={handleLogin}
        onLogout={handleLogout}
        currentView="pricing"
        onViewChange={handleViewChange}
      />

      <PricingSection isAuthenticated={isAuthenticated} onLogin={handleLogin} />

      <footer className="footer">
        <p>
          Made with ❤️ by{' '}
          <a href="https://x.com/jordibosch20" target="_blank" rel="noopener noreferrer">
            @jordibosch20
          </a>
        </p>
      </footer>
    </div>
  );
}

export default PricingPage;
